module.exports = __webpack_public_path__ + "img/poster2.4fb41efc.webp";